import { ApiDashboard } from '../api';
import { InternalApiEntityType } from '../api-internal';
import { generatePath } from 'react-router';
import { InternalNavigation } from '../navigation/helper';

export const nameToPath = (name: string) => name.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();

export const dashboardToPath = (dashboard: ApiDashboard) => nameToPath(dashboard.name);

export const counterpartyDashboardLink = (counterPartyExternalId: string) =>
  generatePath(InternalNavigation.dashboard, { name: 'counterpartydashboard' }) +
  `?counterparty_id=${counterPartyExternalId}`;

export const testResultDashboardLink = (versionId: number, testExecutionId: number) =>
  generatePath(InternalNavigation.dashboard, { name: 'scenariotestresults' }) +
  `?version_id=${versionId}&test_id=${testExecutionId}`;

export const clearanceRuleAnalysisDashboardLink = (runId?: number) =>
  generatePath(InternalNavigation.dashboard, { name: 'clearanceruleanalysis' }) + `?run_id=${runId}`;

export const clearanceRuleClearancesDashboardLink = (contentId: number, entityType: InternalApiEntityType) =>
  generatePath(InternalNavigation.dashboard, { name: 'clearanceruleclearances' }) +
  `?content_id=${contentId}&entity_type=${entityType}`;

export const screeningTestResultDashboardLink = (testId: number) =>
  generatePath(InternalNavigation.dashboard, { name: 'screeningtestresults' }) + `?test_id=${testId}`;
